import React from 'react';
import ReactECharts from 'echarts-for-react';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import { useNavigate } from 'react-router-dom';
import { filterValidData, getLink, getNodeData } from '../utils/serviceFlowUtils';
import { legends } from '../utils/legends';
import { ServiceMapValidation } from '../../common/types/ServiceMapTypes';
import { ErrorBox } from '../../common/components/ErrorBox';

interface Props {
  serviceMaps: ServiceMapValidation[];
  isError: boolean;
  onRefresh: () => void;
}

const ServiceFlow = ({ serviceMaps, isError, onRefresh }: Props) => {
  const nodeData = filterValidData(serviceMaps);
  const navigate = useNavigate();
  const option = {
    tooltip: {},
    color: legends.map((a) => a.nodeColor),
    legend: [
      {
        type: 'plain',
        orient: 'vertical',
        right: 50,
        top: 20,
        bottom: 20,
        data: legends.map((a) => a.name)
      }
    ],
    graphic: [
      {
        type: 'group',
        right: 0,
        bottom: 20,
        top: 'center',
        children: [
          {
            type: 'text',
            style: {
              fill: '#333',
              text: 'NOTE:',
              font: '14px EMprintBold',
              lineHeight: 20
            }
          },
          {
            type: 'text',
            top: '30px',
            style: {
              fill: '#333',
              width: 175,
              overflow: 'break',
              text: 'System availability is based on average system health status over the 5 minutes interval (refresh every 5 minutes)',
              font: '14px EMprintRegular',
              lineHeight: 20
            }
          }
          // {
          //   type: 'text',
          //   top: '130px',
          //   style: {
          //     fill: '#333',
          //     width: 190,
          //     overflow: 'break',
          //     text: '- AVAILABLE (more than 98%) - DEGRADED (less than 98%)',
          //     font: '14px EMprintRegular',
          //     lineHeight: 20
          //   }
          // }
        ]
      }
    ],
    series: [
      {
        legendHoverLink: false,
        type: 'graph',
        layout: 'none',
        data: map(nodeData, getNodeData),
        links: flatMap(nodeData, getLink),
        categories: legends,
        roam: false,
        label: {
          position: 'inside',
          show: true
        },
        lineStyle: {
          color: 'source',
          curveness: 0.3,
          width: 2
        },
        emphasis: {
          focus: 'adjacency',
          lineStyle: {
            width: 10
          }
        }
      }
    ]
  };
  const onEvents = {
    click: (params: any) => {
      if (params.data.domainId) {
        navigate(`detail/${params.data.domainId}`);
      }
    }
  };

  return (
    <>
      {isError && <ErrorBox isRefreshable onRefresh={onRefresh} />}
      {serviceMaps.length > 0 && (
        <ReactECharts
          opts={{ renderer: 'svg', width: 1280, height: 500 }}
          option={option}
          style={{ height: '500px' }}
          onEvents={onEvents}
        />
      )}
    </>
  );
};

export default ServiceFlow;
